export const BLOG_RICH_TEXT_STYLE = `
.blog-content p:empty,
.blog-content p:has(br:only-child) {
  display: none;
}
.blog-content p {
  font-family: var(--font-instrument);
}
.blog-content a {
  text-decoration: underline;
  color: var(--color-primary-purple);
}
.blog-content h1,
.blog-content h2,
.blog-content h3,
.blog-content h4,
.blog-content h5,
.blog-content h6,
.blog-content b,
.blog-content strong {
  font-family: var(--font-bricolage-bold);
}
.blog-content p,
.blog-content ul,
.blog-content ol,
.blog-content li {
  font-size: 13px;
  line-height: 20px;
  margin-bottom: 20px;
}
.blog-content p *,
.blog-content ul *,
.blog-content ol *,
.blog-content li * {
  font-size: inherit !important;
  line-height: inherit !important;
}
.blog-content ul {
  list-style: disc;
  padding-left: 12px;
  margin-bottom: 16px;
}
.blog-content ul li {
  margin-bottom: 16px;
}
.blog-content ul li:last-child {
  margin-bottom: 0;
}
.blog-content ol {
  list-style: decimal;
  padding-left: 12px;
  margin-bottom: 16px;
}
.blog-content ol li {
  margin-bottom: 16px;
}
.blog-content ol li:last-child {
  margin-bottom: 0;
}
.blog-content img {
  width: 100% !important;
  height: auto !important;
  display: block;
  margin-top: 24px;
  margin-bottom: 24px;
}
.blog-content h1 {
  font-size: 28px;
  line-height: 34px;
  margin: 0 0 28px;
}
.blog-content h1:first-child {
  margin-top: 0;
}
.blog-content h1 * {
  font-size: inherit !important;
  line-height: inherit !important;
}
.blog-content h2 {
  font-size: 24px;
  line-height: 29px;
  margin: 48px 0 28px;
}
.blog-content h2:first-child {
  margin-top: 0;
}
.blog-content h2 * {
  font-size: inherit !important;
  line-height: inherit !important;
}
.blog-content h3 {
  font-size: 20px;
  line-height: 24px;
  margin: 44px 0 24px;
}
.blog-content h3:first-child {
  margin-top: 0;
}
.blog-content h3 * {
  font-size: inherit !important;
  line-height: inherit !important;
}
.blog-content h4 {
  font-size: 18px;
  line-height: 22px;
  margin: 40px 0 24px;
}
.blog-content h4:first-child {
  margin-top: 0;
}
.blog-content h4 * {
  font-size: inherit !important;
  line-height: inherit !important;
}
.blog-content h5 {
  font-size: 16px;
  line-height: 20px;
  margin: 32px 0 16px;
}
.blog-content h5:first-child {
  margin-top: 0;
}
.blog-content h5 * {
  font-size: inherit !important;
  line-height: inherit !important;
}
.blog-content h6 {
  font-size: 14px;
  line-height: 17px;
  margin: 32px 0 16px;
}
.blog-content h6:first-child {
  margin-top: 0;
}
.blog-content h6 * {
  font-size: inherit !important;
  line-height: inherit !important;
}
.blog-content h5 + p,
.blog-content h6 + p {
  margin-bottom: 16px;
}
.blog-content blockquote {
  font-size: 12px;
  line-height: 1.5;
  margin: 0 0;
  padding: 8px 24px;
  border-left: 6px solid #b4d5ff;
  background-color: #f5f5f5;
  color: #333;
  font-family: var(--font-instrument);
}
.blog-content video {
  margin: 16px 0;
  width: 100%;
}
.blog-content .table-container {
  border-radius: 0;
  margin-top: 10px;
  overflow-x: auto;
  padding: 0;
  position: relative;
  width: 100%;
}
.blog-content table {
  border-collapse: collapse;
  table-layout: fixed;
}
.blog-content table td,
.blog-content table th {
  border: 1px solid var(--w-e-textarea-border-color, rgba(0, 0, 0, 0.1));
  line-height: 1.5;
  min-width: 30px;
  overflow: hidden;
  overflow-wrap: break-word;
  padding: 3px 5px;
  white-space: pre-wrap;
  word-break: break-all;
}
.blog-content table th {
  background-color: var(--w-e-textarea-slight-bg-color, rgba(0, 0, 0, 0.03));
  font-weight: 700;
  text-align: center;
}
`;

export const getBlogRichTextClassName = () => 'blog-content';

export const resolveGiftHtmlContent = (content: string) =>
  `<style>${BLOG_RICH_TEXT_STYLE}</style>${content}`;
